module.exports = __webpack_public_path__ + "img/cross.76f5e2.svg";